import React, { Component } from "react";
import { Form, Checkbox, Tooltip } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DisplayFlex } from "../../../CommonComponents/commonStyles";
import { recordError } from "../../../utils/commonUtil";
import {
  AccordionHeading,
  Border,
  AccordionWrapper,
  AccordionHeaderWrapper,
  DocumentCenterContent,
  GridAccCheckboxMargin,
  EmptyMessage
} from "./styles";
import GridViewComponent from "./GridViewComponent";
import { CapsuleButton } from './../../../CommonComponents/Commons/commonComponents';

let showMoreData = [];
let checkboxData = [false, false, false, false, false, false];
let AccordionArray = ['Contribution confirmations or tax records', 'Grant confirmations', 'Other Transactions', 'Statements', 'Account documentation', 'Non-account specific documentation']
export class GridViewAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dummyShowMore: false,
      dummy: false,
      showMoreClicked: true,
      checkboxAllClicked: false,
      individualClicked: false
    }
  }

  componentDidMount() {
    showMoreData = []
  }

  ShowMoreButtonClick = (index) => {
    try {
      showMoreData[index] = !showMoreData[index];
      this.setState({ dummyShowMore: true })
    } catch (error) {
      recordError(error);
    }
  }

  handleCheckboxChangeChild = (id, value) => {
    checkboxData[id] = value ? value : null;
    this.setState({ dummy: false })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    if (showMoreData.length === 1) {
      this.props.arrayData.map((index) => {
        showMoreData[index] = false;
      })
    }
    return (
      <>
        {
          (this.props.arrayData.length === 0) ?
            AccordionArray.map((each, index) => {
              return (
                <AccordionWrapper marginBottom="50px" key={`grid-confirmations-${index}`}>
                  <AccordionHeaderWrapper>
                    <DisplayFlex>
                      <GridAccCheckboxMargin>
                        <Form.Item>
                          {getFieldDecorator("checkbox-group")(
                            <Checkbox disabled />
                          )}
                        </Form.Item>
                      </GridAccCheckboxMargin>
                      <AccordionHeading>
                        {each}
                      </AccordionHeading>
                    </DisplayFlex>
                  </AccordionHeaderWrapper>
                  <Border />
                  <AccordionWrapper marginTop="20px">
                    <DocumentCenterContent>You currently have no documents for the time period selected.</DocumentCenterContent>
                  </AccordionWrapper>
                </AccordionWrapper>
              )
            })
            :
            (this.props.arrayData).map((each, index) =>
              (
                <AccordionWrapper marginBottom="30px" key={`grid-documentation-${index}`}>
                  <AccordionHeaderWrapper>
                    <DisplayFlex>
                      <Tooltip placement="topLeft" title="Add to Download Selected List">
                      </Tooltip>
                      <AccordionHeading>
                        {each[0].charAt(0).toUpperCase() + each[0].slice(1) + " "}
                        ({each[1].length})
                      </AccordionHeading>
                    </DisplayFlex>
                    {(this.props.arrayData && each[1].length >= 5) ?
                      <>
                        {showMoreData[index]
                          ? <CapsuleButton data-test="grid-view" alt="Show Less ico" text="Show Less" iconType="arrowUp" onClick={() => this.ShowMoreButtonClick(index)} />
                          : <CapsuleButton data-test="grid-view1" alt="Show More ico" text="Show More" iconType="arrowDown" onClick={() => this.ShowMoreButtonClick(index)} />
                        }
                      </>
                      :
                      ""
                    }
                  </AccordionHeaderWrapper>
                  <Border />
                  <AccordionWrapper marginTop="30px" marginBottom="50px">
                    {(each && each[1].length === 0) ?
                      <div class='ant-empty ant-empty-normal'>
                        <EmptyMessage class='ant-empty-description'>
                          You currently have no documents for the time period selected.
                     </EmptyMessage>
                      </div>
                      :
                      <GridViewComponent
                        eachId={index}
                        docVal={each}
                        showMore={showMoreData[index]}
                        checkbox={checkboxData[index]}
                        handleCheckboxChange={this.handleCheckboxChangeChild}
                        id={each[0].charAt(0).toUpperCase()}
                      />
                    }

                  </AccordionWrapper>
                </AccordionWrapper>
              ))
        }
      </>
    )
  }
}

const GridViewAccordionForm = Form.create({ name: 'granteeOrgContact' })(
  GridViewAccordion,
);

GridViewAccordionForm.propTypes = {
  arrayData: PropTypes.array,
  form: PropTypes.object
}

const mapStateToProps = state => ({
  arrayData: state.getIn(['documentCentre', 'filteredData']),
});

export default connect(mapStateToProps)(GridViewAccordionForm);
